import React from "react";
import { makeStyles, useTheme } from "@seahorse/ui";
import CoTraderSpotTradingViewChart from "./CoTraderSpotTradingViewChart";

const TradingViewChartComponent = CoTraderSpotTradingViewChart as any;

const FX_SPOT_CHART_SYMBOL_MAP: Record<string, string> = {
  EURUSD: "EURUSD=X",
  USDJPY: "JPY=X",
  GBPUSD: "GBPUSD=X",
  USDCHF: "CHF=X",
  USDCAD: "CAD=X",
  AUDUSD: "AUDUSD=X",
  NZDUSD: "NZDUSD=X",
  USDNOK: "NOK=X",
  USDSEK: "SEK=X",
  USDCNY: "CNY=X",
  USDCLP: "CLP=X",
  USDCOP: "COP=X",
  USDMYR: "MYR=X",
  EURHUF: "EURHUF=X",
  USDBRL: "BRL=X",
  USDARS: "ARS=X",
  USDPEN: "PEN=X",
  USDKRW: "KRW=X",
  USDTWD: "TWD=X",
  USDTHB: "THB=X",
  USDMAD: "MAD=X",
  USDHKD: "HKD=X",
  USDPHP: "PHP=X",
  EURPLN: "EURPLN=X",
  USDTRY: "TRY=X",
  USDMXN: "MXN=X",
  USDZAR: "ZAR=X",
  USDIDR: "IDR=X",
  EURRON: "EURRON=X",
  USDINR: "INR=X",
};

const getFxSpotYahooTicker = (currencyPair: string) => {
  const normalizedPair = String(currencyPair || "")
    .trim()
    .toUpperCase()
    .replace(/\//g, "")
    .replace(/=X$/i, "");

  if (!normalizedPair) return "";
  return FX_SPOT_CHART_SYMBOL_MAP[normalizedPair] || `${normalizedPair}=X`;
};

interface PriceChartTileComponentProps {
  currencyPair: string; // Ensure that the type of the prop is defined
  setCurrentPrice: any;
  defaultPeriod?: string;
  defaultInterval?: string;
  customStartDate?: string;
  customEndDate?: string;
  enableLiveUpdates?: boolean;
  hideIntervalControl?: boolean;
  hidePeriodControl?: boolean;
  compactControls?: boolean;
  layoutVersion?: number;
}

const PriceChartTileComponent: React.FunctionComponent<
  PriceChartTileComponentProps
> = (
  {
    currencyPair,
    setCurrentPrice,
    defaultPeriod,
    defaultInterval,
    customStartDate,
    customEndDate,
    enableLiveUpdates,
    hideIntervalControl,
    hidePeriodControl,
    compactControls,
    layoutVersion,
  } // Destructure currencyPair from props
) => {
  const theme = useTheme();
  const yahooTicker = getFxSpotYahooTicker(currencyPair);

  const useStyles = makeStyles({
    container: {
      width: "100%",
      height: "100%",
      // padding: "10px",
    },
    chartContainer: {
      overflow: "auto",
      height: "100%",
      width: "100%",
      backgroundColor: theme.globallink.colors.Grey[1200],
      // padding: "10px",
    },
  });

  const classes = useStyles();

  return (
    <div className={classes.container}>
      <div className={classes.chartContainer}>
        <TradingViewChartComponent
          symbol={yahooTicker}
          streamSymbol={yahooTicker}
          titleOverride={currencyPair}
          defaultPeriod={defaultPeriod}
          defaultInterval={defaultInterval}
          dark
          customStartDate={customStartDate}
          customEndDate={customEndDate}
          enableLiveUpdates={enableLiveUpdates}
          hideIntervalControl={hideIntervalControl}
          hidePeriodControl={hidePeriodControl}
          compactControls={compactControls}
          layoutVersion={layoutVersion}
          seriesDisplay="line"
          onPriceChange={setCurrentPrice}
        />
      </div>
    </div>
  );
};

export default PriceChartTileComponent;
